import React from "react";
import { Popover, OverlayTrigger, Label } from "react-bootstrap";
import PropTypes from "prop-types";
import NavegadorItem from "../../../../../../components/navegador-item/NavegadorItem";
import "../../../../../../css/navegador.css";
import lstrings from "../../../../../../utils/LStrings";
class Navegador extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      style: { top: 220 },
    };
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.scrollHandler);
    this.setState((prev) => {
      return {
        ...prev,
      };
    });
  };

  componentDidUpdate = () => {
    const { hash } = window.location;

    let items = Array.from(document.getElementsByClassName("item"));
    for (let item in items) {
      items[item].classList.remove("active");
    }

    let activo = hash.substr(7) + "-item";
    let item = document.getElementById(activo);
    if (item) {
      item.classList.add("active");
    }
  };

  scrollHandler = () => {
    const dst =
      window.scrollY ||
      window.pageYOffset ||
      document.body.scrollTop +
        ((document.documentElement && document.documentElement.scrollTop) || 0); //eslint-disable-line no-mixed-operators
    let dy = 50;
    if (dst < 220) {
      dy = 50 + (220 - 50) * ((220 - dst) / 220);
      dy = Math.floor(dy);
    }

    const h_sinfooter =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight -
      150;
    const diff_nav = document.documentElement.clientHeight - 587;
    if (dst > h_sinfooter + diff_nav) {
      const p = (dst - h_sinfooter) / 150;
      dy = Math.floor(diff_nav * p) - 75;
      // console.log("scroll handler ", dst, dy, h_sinfooter, (dst - h_sinfooter), diff_nav, p);
    }

    this.setState({ style: { top: dy } });
  };

  render() {
    const pop = <Popover id={`pop-pdf`}>{lstrings.generarReportePdf}</Popover>;

    return (
      <div className="navegador" style={this.state.style}>
        {this.props.showPanels.panelDatosParticulares && (
          <NavegadorItem
            iditem="datosparticulares"
            icon="fa-user"
            titulo={lstrings.datosparticulares_title}
          />
        )}
        {this.props.showPanels.panelContactacion && (
          <NavegadorItem
            iditem="contactacion"
            icon="fa-phone"
            titulo={lstrings.contactacion_title}
          />
        )}
        {this.props.showPanels.panelDatosLaborales && (
          <NavegadorItem
            iditem="datoslaborales"
            icon="fa-briefcase"
            titulo={lstrings.datoslaborales_title}
          />
        )}
        {this.props.showPanels.panelImpuestos && (
          <NavegadorItem
            iditem="impuesto"
            icon="fa-bank"
            titulo={lstrings.impuesto_title}
          />
        )}
        {this.props.showPanels.panelVinculos && (
          <NavegadorItem
            iditem="vinculos"
            icon="fa-share-alt"
            titulo={lstrings.vinculos_title}
          />
        )}
        {this.props.showPanels.panelBienesPersonales && (
          <NavegadorItem
            iditem="bienespersonales"
            icon="fa-home"
            titulo={lstrings.bienes_title}
          />
        )}
        {this.props.showPanels.panelSituacionFinanciera && (
          <NavegadorItem
            iditem="situacionfinanciera"
            icon="fa-usd"
            titulo={lstrings.situacionFinanciera_title}
          />
        )}
        {this.props.showPanels.panelBoletinOficial && (
          <NavegadorItem
            iditem="boletinoficial"
            icon="fa-file-text-o"
            titulo={lstrings.boletinoficial_title}
          />
        )}

        {this.props.pdfEnable && (
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="left"
            overlay={pop}
          >
            <div className="item" id="pdf-item" onClick={this.props.onPDF}>
              <Label bsClass="label pdfNav">PDF</Label>
            </div>
          </OverlayTrigger>
        )}
      </div>
    );
  }
}

Navegador.propTypes = {
  showPanels: PropTypes.any,
  onPDF: PropTypes.func,
  pdfEnable: PropTypes.bool,
};

export default Navegador;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/navegador/Navegador.js